import React, { ReactNode, useEffect, useMemo } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import buildBrandTheme from '../theme/brandTheme';
import { useSkin } from '../theme/SkinProvider';
import { loadBrandFont } from '../theme/lazyFonts'; // item 1516
import useBrandChrome from '../hooks/useBrandChrome';

// item 855 — the Outside Sales (Sales I/O rep) portal is FORCED into the company (Pulse
// Group) brand: no per-device brand source (own/basixColors/stock) and no skin choice —
// always the tenant's own brand on the aurora skin. The rep's only appearance latitude is
// the color mode (light/dark/etc., the shared PortalAppearanceMenu). Replaces
// BrandThemeProvider in the Outside Sales branch of App.tsx.
const OutsideSalesThemeProvider = ({ children }: { children: ReactNode }) => {
  // item 857 — the chrome-only brand read: the OutsideSales role is denied SETTINGS_VIEW,
  // so the full settings/Brand read 403'd here and the portal rendered stock Basix green.
  const { brand } = useBrandChrome();
  const { ledgerTone, colorPref } = useSkin();

  // item 1516 — the tenant's face may be a lazy-loaded family; pull its chunk when it resolves
  const fontFamily = brand?.fontFamily;
  useEffect(() => { loadBrandFont(fontFamily); }, [fontFamily]);

  const theme = useMemo(
    () => buildBrandTheme(brand, 'basix', ledgerTone, colorPref),
    [brand, ledgerTone, colorPref],
  );

  return <ChakraProvider theme={theme}>{children}</ChakraProvider>;
};

export default OutsideSalesThemeProvider;
